import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getBrandIncomeExpense = (brandId) => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/brand/' + brandId, // for android use
    headers: getHeaders(),
  });
};

export const getBrandIncomeExpenseCategory = () => {
    return axios({
      method: 'get',
      url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/category',
      headers: getHeaders(),
    });
  };
  
  export const addBrandIncomeExpense = (brandId, data) => {
    return axios({
      method: 'post',
      url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/brand/' + brandId, // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

  export const updateBrandIncomeExpense = (brandId, data) => {
    return axios({
      method: 'put',
      url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/brand/' + brandId, // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };



  // export const getStoreIncomeExpense = (storeId) => {
  //   return axios({
  //     method: 'get',
  //     // url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/store/' + storeId, // for android use
  //     url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/store/' + storeId + '/map',
  //     headers: getHeaders(),
  //   });
  // };
  
  export const getStoreIncomeExpense = (data) => {
    return axios({
      method: 'post',
      // url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/store/' + storeId, // for android use
      url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/store/',
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };
  

  export const addStoreIncomeExpense = (storeId, data) => {
    return axios({
      method: 'post',
      url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/store/' + storeId, // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

  export const updateStoreIncomeExpense = (storeId, data) => {
    return axios({
      method: 'put',
      url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/store/' + storeId, // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

   export const updateStoreIncomeExpenseByAdmin = (storeId, data) => {
    return axios({
      method: 'put',
      url: STORE_BASE_URL + '/store/api/secure/v1/income-expense/store/' + storeId + '/by-admin', // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };
